interface CategoryFilterProps {
  categories: string[];
  active: string[];
  onChange: (categories: string[]) => void;
  className?: string;
}

// Editorial underline tabs (multi-select). Active tabs get a gold-leaf underline;
// "Todos" resets the selection. See design-system.md §4.6.
export default function CategoryFilter({
  categories,
  active,
  onChange,
  className = '',
}: CategoryFilterProps) {
  const allCategories = ['Todos', ...categories];

  const handleClick = (category: string) => {
    if (category === 'Todos') {
      onChange(['Todos']);
      return;
    }
    const without = active.filter((c) => c !== 'Todos' && c !== category);
    const isSelected = active.includes(category);
    const next = isSelected ? without : [...without, category];
    onChange(next.length === 0 ? ['Todos'] : next);
  };

  return (
    <div
      className={`flex flex-wrap items-center gap-x-6 gap-y-1 ${className}`}
      role="group"
      aria-label="Filtrar por categoria"
    >
      {allCategories.map((category) => {
        const isActive = active.includes(category);
        return (
          <button
            key={category}
            type="button"
            onClick={() => handleClick(category)}
            aria-pressed={isActive}
            className={`border-b-2 pb-2 text-sm transition-colors duration-200 ${
              isActive
                ? 'border-gold-leaf text-on-surface font-bold'
                : 'text-on-surface-light hover:text-on-surface border-transparent font-medium'
            }`}
          >
            {category}
          </button>
        );
      })}
    </div>
  );
}
